import React, { useState, useEffect } from 'react';
import ApplicationService from '../services/axios.service';
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";

const ReasonManager = () => {
  const [reasons, setReasons] = useState([]);
  const [newReason, setNewReason] = useState('');
  const [editReason, setEditReason] = useState({ id: null, name: '' });

  const applicationService = new ApplicationService();

  // Fetch reasons when component is mounted
  useEffect(() => {
    applicationService.getReasons().then(response => {
      setReasons(response.data);
    }).catch(error => {
      console.error("Error fetching reasons:", error);
    });
  }, []);

  // Create a new reason
  const handleCreate = () => {
    if (!newReason) return;
    applicationService.createReason({ name: newReason }).then(response => {
      setReasons([...reasons, response.data]);
      setNewReason('');
    }).catch(error => {
      console.error("Error creating reason:", error);
    });
  };

  // Update an existing reason
  const handleUpdate = (id, updatedName) => {
    if (!updatedName || !id) return;
    applicationService.updateReason(id, { name: updatedName }).then(response => {
      setReasons(reasons.map(reason =>
        reason.id === id ? response.data : reason
      ));
      setEditReason({ id: null, name: '' }); // Clear edit mode
    }).catch(error => {
      console.error("Error updating reason:", error);
    });
  };

  // Delete a reason
  const handleDelete = (id) => {
    applicationService.deleteReason(id).then(() => {
      setReasons(reasons.filter(reason => reason.id !== id));
    }).catch(error => {
      console.error("Error deleting reason:", error);
    });
  };

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white rounded-lg shadow-lg">
      <h1 className="text-3xl font-semibold text-center text-gray-800 mb-6">Reason Manager</h1>

      {/* Reasons List */}
      <div className="mb-6 max-h-[360px] overflow-y-auto">
        <h2 className="text-2xl font-semibold text-gray-700">Reasons</h2>
        <ul className="space-y-3 mt-4">
          {reasons.map(reason => (
            <li key={reason.id} className="flex items-center justify-between p-4 bg-gray-50 rounded-md shadow-sm hover:bg-gray-100 transition gap-4 ">
              {editReason.id === reason.id ? (
                <input
                  type="text"
                  value={editReason.name}
                  onChange={(e) => setEditReason({ ...editReason, name: e.target.value })}
                  className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
                />
              ) : (
                <span className="text-lg text-gray-700">{reason.name}</span>
              )}

              <div className="space-x-2 gap-4 flex flex-row align-items-center  justify-center">
                {editReason.id === reason.id ? (
                  <button
                    onClick={() => handleUpdate(reason.id, editReason.name)}
                    className="px-4 py-2 bg-[#287DD1] text-white rounded-md disabled:bg-gray-400"
                    style={{ color: "#fff", cursor: "pointer" }}
                    disabled={!editReason.name}
                  >
                    Save
                  </button>
                ) : (
                  <EditOutlined
                    onClick={() => setEditReason({ id: reason.id, name: reason.name })}
                    style={{ marginRight: 8, cursor: 'pointer' }}
                  />
                )}

                <DeleteOutlined
                  onClick={() => handleDelete(reason.id)}
                  style={{ marginRight: 8, cursor: 'pointer' }}
                />
              </div>
            </li>
          ))}
        </ul>
      </div>

      {/* Create Reason */}
      <div className="mb-6">
        <h3 className="text-xl font-semibold text-gray-700">Create New Reason</h3>
        <div className="flex items-center space-x-4 mt-4 gap-4">
          <input
            type="text"
            value={newReason}
            onChange={(e) => setNewReason(e.target.value)}
            placeholder="Enter new reason"
            className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
          />
          <button
            onClick={handleCreate}
            disabled={!newReason}
            style={{ color: "#fff" }}
            className= {` px-6 py-3 bg-[#107C41] text-white rounded-md disabled:bg-gray-400" ${newReason  ? 'cursor-pointer' : 'opacity-50 cursor-not-allowed'}`}
          >
            Create
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReasonManager;
